module.exports = __webpack_public_path__ + "img/denmark.d5c38f83.svg";